import { userConstants } from "../constants/login.constants";

 function officerDetails(state = {}, action) {
    switch (action.type) {
        case userConstants.OFFICERDETAILSREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.OFFICERDETAILSREPORT_SUCCESS:
            return {
                items: action.officerDetails
            };
        case userConstants.OFFICERDETAILSREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default officerDetails;